/* FLM — mock data, ported 1:1 from the prototype (Dating App/flm/data.js).
   This is the Phase-1 data layer; screens swap to the live API hooks as the
   backend endpoints land (see docs/04-api-spec.md). Gradient placeholder
   "photos" stay inside the brand palette. */

const G = {
  plum: ['#2D0041', '#7A1FA2'],
  royal: ['#4B006E', '#1a0026'],
  mintdusk: ['#0f1f0a', '#3a5f2a'],
  violet: ['#3a0a54', '#12001c'],
  orchid: ['#5e1287', '#240035'],
  moss: ['#1a2e12', '#0a0a0a'],
  ink: ['#141414', '#2D0041'],
  deep: ['#1f0030', '#4B006E'],
};

const profiles = [
  { id: 'p1', name: 'Aria', age: 26, dist: 2.4, grad: G.plum, verified: true, online: true,
    job: 'Art director', voice: 8,
    bio: 'Gallery hopper, midnight espresso believer. Looking for someone who plans the trip and forgets the map.',
    interests: ['Art', 'Espresso', 'Techno', 'Travel', 'Film'], common: 3,
    pos: { x: 38, y: 30 } },
  { id: 'p2', name: 'Dariush', age: 29, dist: 1.1, grad: G.royal, verified: true, online: false,
    job: 'Product engineer', voice: 7,
    bio: 'I build things on-chain by day and bread by night. My sourdough has a better uptime than most apps.',
    interests: ['Crypto', 'Baking', 'Chess', 'Running'], common: 2,
    pos: { x: 62, y: 22 } },
  { id: 'p3', name: 'Leyla', age: 24, dist: 4.8, grad: G.violet, verified: false, online: true,
    job: 'Medical student', voice: 9,
    bio: 'Fluent in sarcasm and three languages. Will judge you by your playlist, lovingly.',
    interests: ['Vinyl', 'Hiking', 'Poetry', 'Cats', 'Tea'], common: 4,
    pos: { x: 22, y: 56 } },
  { id: 'p4', name: 'Noah', age: 31, dist: 3.2, grad: G.mintdusk, verified: true, online: true,
    job: 'Chef', voice: 6,
    bio: 'I cook for a living and still cook on my day off. First date: I pick the place, you pick the dessert.',
    interests: ['Food', 'Wine', 'Jazz', 'Cycling'], common: 1,
    pos: { x: 74, y: 48 } },
  { id: 'p5', name: 'Sarvin', age: 27, dist: 6.5, grad: G.orchid, verified: true, online: false,
    job: 'Architect', voice: 8,
    bio: "Brutalism apologist. I sketch buildings I'll never build and visit cities I'll never leave.",
    interests: ['Design', 'Photography', 'Climbing', 'Coffee'], common: 3,
    pos: { x: 48, y: 68 } },
  { id: 'p6', name: 'Milan', age: 28, dist: 0.8, grad: G.deep, verified: false, online: true,
    job: 'DJ / producer', voice: 5,
    bio: 'Sets end at 4am, brunch starts at 2pm. Looking for a plus-one to both.',
    interests: ['Techno', 'Vinyl', 'Travel', 'Skating'], common: 2,
    pos: { x: 30, y: 80 } },
  { id: 'p7', name: 'Yasmin', age: 25, dist: 5.1, grad: G.ink, verified: true, online: true,
    job: 'Data scientist', voice: 7,
    bio: 'I A/B tested my bio. This is variant B. Swipe yes to see variant A in person.',
    interests: ['Chess', 'Running', 'Film', 'Ramen', 'Books'], common: 3,
    pos: { x: 66, y: 74 } },
  { id: 'p8', name: 'Kian', age: 30, dist: 8.9, grad: G.moss, verified: true, online: false,
    job: 'Pilot', voice: 9,
    bio: 'I see sunrises twice a week from 11km up. Ground-level ones are better with company.',
    interests: ['Travel', 'Photography', 'Tennis', 'Wine'], common: 1,
    pos: { x: 14, y: 26 } },
];

const interestPool = [
  'Art', 'Espresso', 'Techno', 'Travel', 'Film', 'Crypto', 'Baking', 'Chess',
  'Running', 'Vinyl', 'Hiking', 'Poetry', 'Cats', 'Tea', 'Food', 'Wine',
  'Jazz', 'Cycling', 'Design', 'Photography', 'Climbing', 'Coffee', 'Books', 'Ramen',
];

const chats = [
  { id: 'c1', with: 'p1', unread: 2, lastTs: '21:42',
    msgs: [
      { from: 'them', text: 'Okay your voice intro actually made me laugh', ts: '21:30' },
      { from: 'me', text: 'That was take 11. The first ten were too smooth', ts: '21:33' },
      { from: 'them', text: 'Smooth is overrated. Espresso this weekend?', ts: '21:40' },
      { from: 'them', text: 'I know a place with 9 beans on the menu', ts: '21:42' },
    ] },
  { id: 'c2', with: 'p4', unread: 0, lastTs: '18:05',
    msgs: [
      { from: 'them', text: 'Dessert is non-negotiable then 🤝', ts: '17:58' },
      { from: 'me', text: "Pistachio anything and we're good", ts: '18:05' },
    ] },
  { id: 'c3', with: 'p7', unread: 1, lastTs: '12:19',
    msgs: [
      { from: 'them', text: 'Variant A confirmed better in person?', ts: '12:19' },
    ] },
];

const icebreakers = [
  'Two truths and a lie — go.',
  "What's your most controversial food take?",
  'Describe your week in three emojis.',
  'Window or aisle?',
  'What song is stuck in your head right now?',
];

const posts = [
  { id: 's1', by: 'p3', time: '2h', grad: G.plum, likes: 47, liked: false,
    text: 'Found a rooftop where the city actually goes quiet. Not telling where. Okay maybe telling one person.' },
  { id: 's2', by: 'p6', time: '5h', grad: G.deep, likes: 132, liked: true,
    text: 'Closing set Friday. Guest list has exactly one free spot.' },
  { id: 's3', by: 'p5', time: '8h', grad: G.mintdusk, likes: 89, liked: false,
    text: "Sketching at the museum café again. The barista thinks I'm a regular. The barista is right." },
];

const stories = ['p1', 'p3', 'p4', 'p6', 'p7'];

const events = [
  { id: 'e1', title: 'Rooftop Cinema Night', venue: 'Le Bordel, Roof 9', when: 'FRI 21:00', going: 38, grad: G.deep },
  { id: 'e2', title: 'Espresso & Chess Mixer', venue: 'Café Méridien', when: 'SAT 16:00', going: 22, grad: G.plum },
  { id: 'e3', title: 'Vinyl Listening Room', venue: 'Studio Noir', when: 'SAT 22:00', going: 54, grad: G.violet },
];

/* Canonical seed prices (docs/00-foundation.md §10.1). */
const plans = [
  { id: 'spark', name: 'Spark', priceTon: '9', priceUsd: '19', period: 1, featured: false,
    perks: ['perkUnlimited', 'perkSeeLikes', 'perkSparks'] },
  { id: 'pulse', name: 'Pulse', priceTon: '21', priceUsd: '45', period: 3, featured: true,
    perks: ['perkUnlimited', 'perkSeeLikes', 'perkSparks', 'perkBoost', 'perkIncognito', 'perkPassport'] },
  { id: 'infinity', name: 'Infinity', priceTon: '60', priceUsd: '129', period: 12, featured: false,
    perks: ['perkUnlimited', 'perkSeeLikes', 'perkSparks', 'perkBoost', 'perkIncognito', 'perkPassport', 'perkVerifiedOnly', 'perkConcierge'] },
];

const coins = [
  { id: 'ton', name: 'TON', sub: 'Toncoin', sym: '💎', rate: 1, badge: 'RECOMMENDED' },
  { id: 'usdt', name: 'USDT', sub: 'TON network', sym: '₮', rate: 2.1 },
  { id: 'btc', name: 'BTC', sub: 'Bitcoin', sym: '₿', rate: 0.000031 },
  { id: 'eth', name: 'ETH', sub: 'Ethereum', sym: 'Ξ', rate: 0.00088 },
  { id: 'stars', name: 'Stars', sub: 'Telegram Stars', sym: '★', rate: 105 },
];

/* Canonical gift prices (docs/00-foundation.md §10.2). */
const gifts = [
  { id: 'g1', name: 'Rose', ton: '1' },
  { id: 'g2', name: 'Champagne', ton: '3' },
  { id: 'g3', name: 'Diamond', ton: '10' },
  { id: 'g4', name: 'Meteor', ton: '25' },
];

const byId = (id) => profiles.find((p) => p.id === id);

export const FLM_DATA = {
  profiles, interestPool, chats, icebreakers, posts, stories, events, plans, coins, gifts, byId,
};

/* Who already said yes to "you" — drives instant matches (moved from discover.jsx). */
export const LIKES_YOU = new Set(['p1', 'p4', 'p7', 'p3', 'p6']);
